// Defines the canonical menu order for sidebar navigation
// Menu items will be displayed in this exact order
export const MENU_ORDER = [
  'Dashboard',
  'Place An Order',
  'Existing Orders',
  'Deleted Orders',
  'Un-Synced CubiCasa Orders',
  'Sales Customer Info',
  'Estimating Customer Info',
  'Pricing Contracts',
  'One off Unit Quotes',
  'Product Catalog',
  'Labor Catalog',
  'Kits',
  'Admin'
];

// Create a map for O(1) lookup during sorting
// This maps menu names to their display order index
export const MENU_ORDER_MAP = MENU_ORDER.reduce((acc, name, index) => {
  acc[name] = index;
  return acc;
}, {});

// Canonical set of every top-level MENU + SUB-MENU destination that is governed
// by role permissions. This is the ONLY list the permission guard polices: the
// guard restricts direct-URL access to these paths when the logged-in user is
// not permitted to open them. Any other route (detail pages, value-lists,
// sub-pages, etc.) is intentionally left untouched.
//
// Sub-menu paths are written here in their real (absolute) route form. In the
// api some sub-menu urls arrive relative to the admin section
// (e.g. "labor/catgeory" -> "/admin/labor/catgeory"); the guard normalizes them
// to this same absolute form before comparing.
export const MENU_GUARD_URLS = [
  // Top-level menus
  '/dashboard',
  '/place-order',
  '/existing-orders',
  '/sale-customer-info',
  '/estimating-customer-info',
  '/PricingContracts',
  '/ProductCatalog',
  '/admin/labor/items',
  '/kits',
  '/admin',
  '/deleted-orders',
  '/unsynced-cubicasa-orders',
  '/unit-quotes',
  // Admin sub-menus
  '/product-type',
  '/admin/product-catalog/store-list',
  '/admin/labor/catgeory',
  '/admin/sales-person/category',
  '/role',
  '/employee',
  '/customer-approval',
  '/customer-priority',
  '/lost-customer-parameters'
];
